module.exports = __webpack_public_path__ + "img/pc_3.e1e4ce29.jpg";